export enum StavSubjektu {
	POVOLEN = 'POVOLEN',
	ZRUSEN = 'ZRUSEN'
}
